import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { theme } from "../theme";
import logo from "../PhotosGallery/wheel.png"; // Import the logo

const NavContainer = styled.nav`
   display: flex;
  justify-content: space-between;
  align-items: center;
 
  color: ${({ theme }) => theme.colors.text};
  padding: 2em;
  width: 100%;
  position: relative;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  
  
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
  z-index: 10;
  width: 90px; /* Adjust as needed */
  height: auto;
  margin-right: 20px;
  background: linear-gradient(45deg, #b8860b, #d4af37); /* Gold gradient */
  padding: 5px;
  border-radius: 10px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7); /* Depth effect */

  animation: logo-shine 3s infinite alternate;

  @keyframes logo-shine {
    0% {
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7),
        0 0 10px rgba(212, 175, 55, 0.7);
    }
    100% {
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7),
        0 0 20px rgba(212, 175, 55, 0.9), 0 0 30px rgba(212, 175, 55, 0.8);
    }
  }

  transition: transform 0.3s ease, color 0.3s ease;
  &:hover {
    transform: scale(1.08);
    color: ${theme.colors.primary};
  }
`;

const SchoolName = styled.h1`
  z-index: 10;
  font-size: 3.5em;
  margin: 1px;
  padding-left: 15px;
  flex: 1;
  background: linear-gradient(45deg, #b8860b, #d4af37);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  position: relative;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);

  animation: shine 3s infinite alternate;

  @keyframes shine {
    0% {
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6),
        0 0 10px rgba(212, 175, 55, 0.7);
    }
    100% {
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6),
        0 0 20px rgba(212, 175, 55, 0.9), 0 0 30px rgba(212, 175, 55, 0.8);
    }
  }
  transition: transform 0.3s ease, color 0.3s ease;
  &:hover {
    transform: scale(1.08);
    color: ${theme.colors.primary};
  }
`;

const NavLinks = styled.ul<{ isOpen: boolean }>`
  list-style: none;
  display: flex;
  align-items: center;
  position: relative;
  margin-left: auto;

  @media (max-width: 768px) {
    display: ${(props) => (props.isOpen ? "flex" : "none")};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: ${theme.colors.background};
    width: 100%;
    padding: 1em;
    z-index: 1;
  }
`;

const NavLinkItem = styled.li`
  font-size: 1.5em;
  padding: 0 20px;

  & a {
    color: ${theme.colors.primary};
    text-decoration: none;
  }

  transition: transform 0.3s ease, color 0.3s ease;
  &:hover {
    transform: scale(1.3);
    color: ${theme.colors.primary};
  }
`;

const HamburgerMenu = styled.div`
  display: none; // Hide on large screens
  cursor: pointer;

  & div {
    width: 30px;
    height: 4px;
    background: darkgoldenrod;
    margin: 5px;
    transition: all 0.3s;
  }

  @media (max-width: 768px) {
    display: block; // Show on small screens
  }
`;

const Navigation: React.FC = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const handleLinkClick = () => {
    setIsNavOpen(false); // Close the nav when a link is clicked
  };

  return (
    <NavContainer>
      <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
        <LogoContainer>
          <LogoImage src={logo} alt="Best Rijschool Logo" />
          <SchoolName>Best Rijschool</SchoolName>
        </LogoContainer>
      </Link>
      <HamburgerMenu onClick={() => setIsNavOpen(!isNavOpen)}>
        <div />
        <div />
        <div />
      </HamburgerMenu>
      <NavLinks isOpen={isNavOpen}>
        <NavLinkItem>
          <Link to="/" onClick={handleLinkClick}>
            Start
          </Link>
        </NavLinkItem>
        <NavLinkItem>
          <Link to="/courses" onClick={handleLinkClick}>
            Prijzen
          </Link>
        </NavLinkItem>
        <NavLinkItem>
          <Link to="/gallery" onClick={handleLinkClick}>
            Galerij
          </Link>
        </NavLinkItem>
        <NavLinkItem>
          <Link to="/contact" onClick={handleLinkClick}>
            Contact
          </Link>
        </NavLinkItem>
      </NavLinks>
    </NavContainer>
  );
};

export default Navigation;
